/**
 * @generated SignedSource<<53501a3cdefe37344eda446c082034d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueCard_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly fieldsById: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string;
        readonly " $fragmentSpreads": FragmentRefs<"assignee_softwareReleasesVersionDetailIssueList" | "priority_softwareReleasesVersionDetailIssueList" | "status_softwareReleasesVersionDetailIssueList" | "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField" | "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField">;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly issueId: string;
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"delivery_softwareReleasesVersionDetailIssueList" | "development_softwareReleasesVersionDetailIssueList" | "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue" | "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue" | "summary_softwareReleasesVersionDetailIssueList_jiraIssue" | "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue">;
  readonly " $fragmentType": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type issueCard_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: issueCard_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCard_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "issueId"
      },
      "action": "THROW",
      "path": "issueId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Literal",
            "name": "ids",
            "value": [
              "priority",
              "summary",
              "assignee",
              "status",
              "issuetype"
            ]
          }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      "action": "THROW",
                      "path": "fieldsById.edges.node.fieldId"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "status_softwareReleasesVersionDetailIssueList"
                        }
                      ],
                      "type": "JiraStatusField"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "assignee_softwareReleasesVersionDetailIssueList"
                        }
                      ],
                      "type": "JiraSingleSelectUserPickerField"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField"
                        }
                      ],
                      "type": "JiraSingleLineTextField"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField"
                        }
                      ],
                      "type": "JiraIssueTypeField"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "priority_softwareReleasesVersionDetailIssueList"
                        }
                      ],
                      "type": "JiraPriorityField"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "fieldsById.edges"
          }
        ],
        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
      },
      "action": "THROW",
      "path": "fieldsById"
    },
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "delivery_softwareReleasesVersionDetailIssueList"
        },
        {
          "kind": "FragmentSpread",
          "name": "development_softwareReleasesVersionDetailIssueList"
        },
        {
          "kind": "FragmentSpread",
          "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "81587616f95bbce4695593a62ffa6d45";

export default node;
